import React, { useEffect, useState } from "react";
import {
  CustomButton2,
  CustomInput,
  CustomLeaflet,
  CustomView,
} from "../../../../../../components";
import { ILocation } from "../../../../../../types/common.interface";
import { ICreateStudent } from "../../../../../../types/student.interface";
import Cookies from "js-cookie";

type Props = {
  defaultValue: ICreateStudent;
  onSubmit: (formData: ICreateStudent) => void;
  onBack: (formData: ICreateStudent) => void;
};

const StudentLocation = (props: Props) => {
  const [address, setAddress] = React.useState<string>(
    props?.defaultValue?.address ? props.defaultValue.address : ""
  );
  const [nationality, setNationality] = React.useState<string>(
    props?.defaultValue?.nationality ? props.defaultValue.nationality : "IRANIAN"
  );
  const [location, setLocation] = React.useState<ILocation>({
    lng: props?.defaultValue?.lng ? props?.defaultValue?.lng : "",
    lat: props?.defaultValue?.lat ? props?.defaultValue?.lat : "",
  });

  useEffect(() => {
    setLocation({
      lng: props?.defaultValue?.lng ? props?.defaultValue?.lng : "",
      lat: props?.defaultValue?.lat ? props?.defaultValue?.lat : "",
    });
  }, [props?.defaultValue?.lng, props?.defaultValue?.lat]);

  const [errors, setErrors] = useState({ latLng: "" });

  function onSubmitBack() {
    props.onBack({
      ...props.defaultValue,
      lat: location.lat,
      lng: location.lng,
      nationality,
      address,
    });
  }

  function onSubmitForward() {
    props.onSubmit({
      ...props.defaultValue,
      lat: location?.lat,
      lng: location?.lng,
      nationality,
      address,
    });
  }

  let cityInfo: any;

  Cookies.get("city") != "undefined"
    ? (cityInfo = JSON.parse(Cookies.get("city") as string))
    : (cityInfo = undefined);

  return (
    <CustomView.Container className="create-form-content">
      <CustomView.Row className="form-row">
        {/*<CustomView.Column className="form-colum">*/}
        {/*  <CustomInput*/}
        {/*    label="ملیت"*/}
        {/*    value={nationality}*/}
        {/*    placeHolder="ایران"*/}
        {/*    onValueChange={(event: React.ChangeEvent<HTMLInputElement>) =>*/}
        {/*      setNationality(event.target.value)*/}
        {/*    }*/}
        {/*  />*/}
        {/*</CustomView.Column>*/}
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum">
          <CustomInput
            label="آدرس"
            value={address}
            placeHolder="آدرس"
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setAddress(event.target.value)
            }
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum dropdown" medium={12}>
          <div className="error">{errors.latLng !== "" && errors.latLng}</div>
          <CustomLeaflet
            defaultLatArea={cityInfo?.lat}
            defaultLngArea={cityInfo?.lng}
            defaultLat={location.lat}
            defaultLng={location.lng}
            onChangeLatAndLng={(lat: any, lng: any) => {
              setLocation({ lat, lng });
              setErrors({ latLng: "" });
            }}
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={onSubmitBack} title="قبلی" type="danger" />
        </CustomView.Column>
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={onSubmitForward} title="بعدی" />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default StudentLocation;
